<template>
    <div>
        <table class="table w-100 table-hover lightgray-content">
            <thead>
                <tr>
                    <th></th>
                    {{  }}
                    <th>{{ !event.reserva_instalaciones ? $t('evento.tipo_entrada') : $t('gracias.tipo_reserva') }}</th>
                    <th>{{ $t('evento.precio') }}</th>
                    <th>{{ $t('evento.cantidad') }}</th>
                </tr>
            </thead>
            <tbody>
                <template v-for="(entrada, index) in entradas">
                    <tr :key="index" valign="middle">
                        <td :class="getEntradasMax(entrada) > 0 ? 'availability' : 'availability not-available'"></td>
                        <td>{{ entrada.name }}</td>
                        <td>{{ entrada.total_price | formatear_precio }}</td>
                        <td>
                            <div class="form-group m-0" v-if="getEntradasMax(entrada) > 0">
                                <select class="form-control" v-model="entrada.unidades" @change="actualizar" :disabled="puede_seleccionar ? false : true">
                                    <template v-for="i in getEntradasMax(entrada)">
                                        <template v-if="i >= getEntradasMin(entrada)">
                                            <option :key="i" :value="i">{{ i }}</option>
                                        </template>                                        
                                    </template>                                            
                                </select>
                            </div> 
                            <template v-else>
                                <template v-if="entrada.en_sesion == true">
                                    <b class="text-danger">En estos momentos un usuario está comprando las últimas {{ footer.termino_entradas }}, si no finaliza la compra se liberarán.</b>
                                </template>
                                <template v-else>
                                    <b class="text-danger" style="text-transform: uppercase">{{ footer.termino_entradas }} AGOTADAS</b>
                                </template>                                
                            </template>                                       
                        </td>
                    </tr>
                    <tr :key="index + '-'">
                        <td colspan="5" class="pb-0">
                            <b-row class="pl-3">
                                <ResumenPrecioComponent
                                    :price="entrada.price"
                                    :price_management="entrada.price_management"
                                    :price_management_interno="entrada.price_management_interno"
                                    :iva="iva"
                                />
                                <b-col cols="12" style="text-transform: none;" class="mt-1 mb-1">
                                    {{ entrada.informacion }}
                                </b-col>
                            </b-row>                                                        
                        </td>
                    </tr>
                </template>
            </tbody>
        </table>
    </div>
</template>

<script>
import ResumenPrecioComponent from "@/components/frontend/compra/components/ResumenPrecioComponent.vue";

export default {
    components: {ResumenPrecioComponent},
    props: ['entradas', 'puede_seleccionar' , 'iva', 'event'],
    computed: {
        footer() {
            return this.$store.getters.getFooter;
        },
        teatro() {
            return this.$store.getters.getTeatro;
        },
    },
    methods: {
        actualizar() {
            this.loading = true;

            var ok = false;
            for(var i in this.entradas) {
                if(this.entradas[i].unidades > 0) {
                    ok = true;
                }
            }

            if(ok) {
                this.$emit('actualizar', true);
            } else {
                this.$emit('actualizar', false);
            }
            this.loading = false;
        },
        getEntradasMax(entrada) {
            var max = entrada.n_entradas_max ? entrada.n_entradas_max : 8;

            return entrada.units > max ? max : entrada.units;
        },
        getEntradasMin(entrada) {
            return entrada.n_entradas_min ? entrada.n_entradas_min : 1;
        }
    }
}
</script>
